// extracted by mini-css-extract-plugin
export default {"tooltip":"sp-z","sharingV2":"tp-z","sharingIconsV2":"up-z","links":"vp-z","link":"wp-z","facebookV2":"xp-z","twitterV2":"yp-z","pinterestV2":"zp-z"};